module.exports = __webpack_public_path__ + "img/rosepetal-dep-esbelt.15dce336.jpg";